import {QUALIFICATION_KEY_TYPE} from "@/shared/model";
import {z} from "zod";

const schema = z.object({
	salesSummaryType: QUALIFICATION_KEY_TYPE,
	target: z.number().nullable(),
	actual: z.number()
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeEachSummaryModel = {schema, model};
export type IEmployeeEachSummaryModel = z.infer<typeof EmployeeEachSummaryModel.model>;
export const DEFAULT_EMPLOYEE_EACH_SUMMARY: IEmployeeEachSummaryModel = {
	salesSummaryType: "NORMAL_INSURANCE",
	target: 0,
	actual: 0
};
